// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SortLabel--moderator":"fp_a bhn_hs","SortLabel__newFeature":"fp_b bhn_vj bhn_vx"};